<template>
  <div>
    <b-form-radio-group
       v-model="radio"
       :name="storeInArray ? `formData${storeInArray}[${currentField.tagname}]` : `formData[${currentField.tagname}]`"
       :options="currentField.options"
       text-field="optionLabel"
       value-field="optionValue"
       :class="{'is-invalid' : error}"
     ></b-form-radio-group>
     <span class="invalid-feedback" role="alert" v-if="error">
           <strong>{{ error }}</strong>
       </span>
  </div>
</template>

<script>
import fetchData from '@/api/fetch-data';
export default {
  name: 'RadioButton',
  props: ['currentField', 'value', 'error', 'visible', 'storeInArray'],
  data() {
    return {
      radio: this.value ? this.value : ''
    }
  },
  watch: {
    value (value) {
      this.radio = value ?? ''
    },

    radio(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  mounted() {
    if (this.currentField.isFromFormList) {
      let dataUrl = '/lists/' + this.currentField.formListTag;
      let valueField = 'value';
      let labelField = 'label';
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        // console.log(data)
        this.currentField.options = data;
      });
    }
  }
}
</script>
